import { render, staticRenderFns } from "./IbAppToolbar.vue?vue&type=template&id=a229319c"
import script from "./IbAppToolbar.vue?vue&type=script&lang=js"
export * from "./IbAppToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports